import script from "./BaseMultiselect.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseMultiselect.vue?vue&type=script&setup=true&lang=ts"

import "./BaseMultiselect.vue?vue&type=style&index=0&id=0e84e313&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e84e313"]])

export default __exports__